module.exports = __webpack_public_path__ + "img/2.5ad7b10c.svg";